import { render, staticRenderFns } from "./archive-table.vue?vue&type=template&id=8f1de73c&scoped=true"
import script from "./archive-table.vue?vue&type=script&lang=js"
export * from "./archive-table.vue?vue&type=script&lang=js"
import style0 from "./archive-table.vue?vue&type=style&index=0&id=8f1de73c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1de73c",
  null
  
)

export default component.exports